//
import React, { useState, useRef, useEffect } from 'react';

import '../../css/menu.css';
import '../../css/pagemenu.css';


export function PageMenuElement(title, menubuttons, onclickEvent, showback) {

    const [menuItems] = useState(menubuttons);
    //const [backAction, setBackAction] = useState();    
    
    let menuVisible = useRef(false);
    let backAction = useRef('');
    let menuCount = useRef(0);
    let backVisible = useRef(showback);
    

    function handleMenuClick(onclickname) {
        if (onclickEvent) {
            onclickEvent(onclickname);
        }
    }


    function RenderMenuItems(menuitems) {
        let result = [];
        for (let j = 0; j < menuitems.length; j++) {
            if(menuItems[j].permission_name == null || sessionStorage['permission_names'].includes(menuItems[j].permission_name))
            {
                if(menuItems[j].onclick === 'goback')
                {                    
                    backAction.current = menuItems[j].onclick;   
                    if(document.getElementById("menubarback"))
                    {                 
                        if(backVisible.current === false)
                        {
                            document.getElementById("menubarback").style.display="none"; 
                        }
                        else
                        {
                            document.getElementById("menubarback").style.display="flex"; 
                        }
                    }
                }
                else
                {
                    menuCount.current++;
                    result.push(<div key={menuitems[j].name} className='pagemenuitem' onClick={()=>{handleMenuClick(menuItems[j].onclick)}}>{menuitems[j].name}</div>);
                }
            }
        }
        return result;
    }

    function handleToggleMenu() {
        if (menuVisible.current === true) {
            document.getElementById('menupopout').style.display = "none";
            menuVisible.current = false;
        }
        else {
            if(menuCount.current > 0)
            {
            document.getElementById('menupopout').style.display = "block";
            menuVisible.current = true;
            }
        }
    }

    useEffect(() => {
  
        if(backVisible.current === false)
        {
            if(document.getElementById('menubarback')!=null)
            {
                document.getElementById('menubarback').style.display = "none";
            }
        }

        if(menuItems.length === 0)
        {
            document.getElementById('menuiconholder').style.display = "none";
            
        }

        window.addEventListener('click', function (e) {
            let el = document.getElementById('menuiconholder');
            if(el)
            {
            if (el.contains(e.target)) {
                // Clicked in box
            } else {
                if (menuVisible.current === true) {
                    handleToggleMenu();
                }
            }
        }
        });
    });

    return (
        <>
            <div className='pagemenubar'>


                <div className='pagemenutitle'>
                    <div className='pagebackdiv' id="menubarback">
                        <img className='pagebackicon' src='imgs/Chevron.png' alt='Menu' onClick={()=>{handleMenuClick(backAction.current)}} />
                    </div>
                    {title}

                    <div className='pagemenuicondiv' id="menuiconholder">
                        <img className='pagemenuicon' src='imgs/GearWhite.png' alt='Menu' onClick={handleToggleMenu} />
                    </div>
                </div>
            </div>
            <div className='pagemenupopout' id='menupopout'>
                {RenderMenuItems(menuItems)}
            </div>
            <div style={{"height":"1em"}}></div>
        </>
    );
}












